import Container from 'typedi';
import ActivityService from './ActivityService';
import TripRepository from '../repositories/TripRepository';

class TripService {
  activityService;
  tripRepository;
  constructor() {
    this.activityService = Container.get(ActivityService);
    this.tripRepository = Container.get(TripRepository);
  }
  getTrips = async (page, rowsPerPage) => await this.tripRepository.getTrips(page, rowsPerPage);
  getTripsByIdRoute = async (idRoute) => await this.tripRepository.getTripsByIdRoute(idRoute);

  processMassiveTripSubmission(trips, spots, activityTypes, itemTypes, tags) {
    const requestTrips = [];
    if (trips.length) {
      let rowNumber = 0;
      trips.forEach((trip) => {
        const timeEditTrip = trip.timeEdit * 60;
        const now = new Date().getTime();
        let tripDestinationSpot = null;
        let tripBody = null;
        //Verifica si el trip es de tipo temporal
        if (trip.type == 'Temporal') {
          tripDestinationSpot = trip.destinationTemporal;
        } else {
          tripDestinationSpot = spots.find((s) => {
            //Verifico si el spot del listado es temporal
            if (s.type !== 'Temporal' && s.name === trip.tripDestination) {
              return s;
            }
            //Si es temporal entonces transformo el nombre del spot 
            else if (s.type === 'Temporal') {
              const splitAddress = s.name.split(',');
              const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
              if (newName === trip.tripDestination) {
                return s;
              }
            }
          });
        }

        const requestActivities = trip.activities
          ? this.activityService.processMassiveActivitySubmission(trip.activities, activityTypes, itemTypes, tags)
          : [];
        if (trip.type == 'Temporal') {
          tripBody = {
            destination: {
              id: null,
              name: rowNumber + '_' + now,
              address: {
                city: tripDestinationSpot.address.city,
                postalCode: null,
                state: tripDestinationSpot.address.state,
                street: tripDestinationSpot.address.street,
                lat: null,
                lon: null,
                country: {
                  id: tripDestinationSpot.address.country.id,
                  name: tripDestinationSpot.address.country.name,
                },
              },
            },
            editTime: Math.round(Number(timeEditTrip)),
            activities: requestActivities,
          };
        } else {
          tripBody = {
            destination: {
              id: tripDestinationSpot.id,
            },
            editTime: Math.round(Number(timeEditTrip)),
            activities: requestActivities,
          };
        }
        if(trip.extraField){
          tripBody = {
            ...tripBody,
            extraData: {
              extraData1: trip.extraField,
            }
          }
        }
        tripBody.setOperatorDirect = trip.setOperatorDirect;
        requestTrips.push(tripBody);
        rowNumber++;
      });
    }
    return requestTrips;
  }
}

Container.set({ id: TripService, type: TripService });

export default TripService;
